<template>
  <div :class="$style.base">
    <NavItemMobile
      v-for="item in items"
      :key="item.routeName"
      mainItem
      :item="item"
      @click="$emit('navItemClick')"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import type { NavItem } from './MobileOverlay.vue';
import NavItemMobile from './NavItemMobile.vue';

defineProps<{
  items: NavItem[];
}>();

defineEmits(['navItemClick']);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  justify-content: space-around;
  gap: $spacing;
}
</style>
